import { Attachment } from './Attachment';
import { ErroredModel } from './ErroredModel';
import { PaginationMeta } from './pagination';

export enum NoteableType {
  ACCOUNT = 'Account',
  EVENT = 'Event',
  EMPLOYEE = 'Employee',
  CONTACT = 'Contact',
  TASK = 'Task',
}

export type Noteable = {
  noteableType: NoteableType;
  noteableUuid: string;
};

export type Note = ErroredModel & {
  id?: number;
  uuid?: string;
  text: string;
  user_id?: number;
  user_email?: string;
  employee_avatar_url?: string;
  employee_display_name?: string;
  employee_uuid?: string;
  noteable_type: NoteableType;
  noteable_uuid: string;
  mentions: string[];
  created_at?: string;
  updated_at?: string;
  edited_at?: string;
  pinned_at?: string | null;
  parent_uuid?: string | null;
  pin?: boolean | null;
  children?: Note[];
  attachment_data?: Attachment[];
};

export type NoteResponse = {
  data: Note[];
  meta: PaginationMeta;
};

export type NoteEmployeeUuidResponse = {
  data: string[];
};
